import { useMemo } from 'react'
import { dateFormatter } from 'helpers'

const useStartTime = startTime =>
  useMemo(
    () => ({
      formattedDate: dateFormatter.formatStartDate(startTime),
      startTimeMilliseconds: new Date(startTime).getTime(),
      isBefore24Hours: dateFormatter.isBefore24Hours(startTime),
    }),
    [startTime]
  )

export default useStartTime
